import { AuthToken } from '../../api/payloads/AuthToken'
import jwt_decode from 'jwt-decode'
import { UserRole } from '../../api/sharedTypes/User'

export const AUTH_LOCAL_STORAGE_KEY = 'auth-token'
export const AUTH_SLICE_NAME = 'auth'
export const SET_AUTH_STATE_ACTION_NAME = 'setAuthState'

export type AuthReduxState = {
    isAuthenticated: boolean
    userName: string
    token: string
    parsedToken: AuthToken
    role: UserRole
}

export const getEmptyAuthState = (): AuthReduxState => {
    return {
        isAuthenticated: false,
        token: '',
        parsedToken: {
            CreatedTimestamp: 0,
            Username: '',
            UserId: '',
            expiration: 0,
            IntegrityHash: '',
            RefreshIntervalInSeconds: 0,
            RefreshTimestamp: 0,
            Role: UserRole.NotSet,
        },
        userName: '',
        role: UserRole.NotSet,
    }
}

export const parseJwtEncodedTokenAndGetReduxState = (encodedToken: string): AuthReduxState => {
    const decoded = jwt_decode(encodedToken) as AuthToken
    if (decoded.expiration < Math.floor(new Date().getTime() / 1000.0)) {
        // expired token
        console.debug('Found expired token, returning empty auth state...')
        return {
            isAuthenticated: false,
            parsedToken: {
                CreatedTimestamp: 0,
                Username: '',
                UserId: '',
                expiration: 0,
                IntegrityHash: '',
                RefreshIntervalInSeconds: 0,
                RefreshTimestamp: 0,
                Role: UserRole.NotSet,
            },
            token: '',
            userName: '',
            role: UserRole.NotSet,
        }
    } else
        return {
            isAuthenticated: true,
            parsedToken: decoded,
            token: encodedToken,
            userName: decoded.Username,
            role: decoded.Role,
        }
}
